import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AuditTrail() {
  const [logs, setLogs] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setLogs(data)).catch(() => setLogs([])); }, []);
  if (!logs) return <div className="py-20 text-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin inline" /></div>;
  const filtered = logs.filter((l) => !q || JSON.stringify(l).toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <div className="mb-5 flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-head text-2xl font-bold tracking-tight text-slate-900">Audit Trail</h1>
          <p className="text-sm text-slate-500 mt-0.5">Immutable business & security audit records.</p>
        </div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter logs…" className="w-64" data-testid="audit-filter" />
      </div>
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <div className="overflow-x-auto max-h-[70vh]">
          <Table className="pf-table">
            <TableHeader>
              <TableRow className="bg-slate-50 hover:bg-slate-50 sticky top-0">
                {["Time", "Layer", "Action", "Entity", "User", "Role", "Detail"].map((h) => (
                  <TableHead key={h} className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold py-2.5 px-3">{h}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {filtered.map((l) => (
                <TableRow key={l.id} className="border-slate-100" data-testid={`audit-row-${l.id}`}>
                  <TableCell className="py-2 px-3 text-xs text-slate-500 whitespace-nowrap">{fmtDate(l.created_at)}</TableCell>
                  <TableCell className="py-2 px-3">
                    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold ${l.layer === "security" ? "text-rose-600" : "text-slate-600"}`}>
                      {l.layer === "security" && <ShieldCheck className="h-3 w-3" />}{l.layer}
                    </span>
                  </TableCell>
                  <TableCell className="py-2 px-3 text-[13px] font-medium text-slate-800">{l.action}</TableCell>
                  <TableCell className="py-2 px-3 text-xs mono text-slate-600">{l.entity_type}</TableCell>
                  <TableCell className="py-2 px-3 text-xs text-slate-600">{l.user_email || "—"}</TableCell>
                  <TableCell className="py-2 px-3 text-xs text-slate-500 capitalize">{l.user_role || "—"}</TableCell>
                  <TableCell className="py-2 px-3 text-xs text-slate-400 mono max-w-[200px] truncate">{l.detail ? JSON.stringify(l.detail) : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
